import { helpers, required, email, minLength, maxLength } from '@vuelidate/validators'

const useValidation = () => {
  const REQUIRED_FIELD_MESSAGE = 'This field is required'
  const REQUIRED_FIELD_NUMERIC = 'Must be a number'
  const REQUIRED_FIELD_SELECT = 'Please select an option'
  const REQUIRED_FIELD_CHECKBOX = 'Please check an option'
  const REQUIRED_FIELD_RADIO = 'Please select an option'
  const REQUIRED_FIELD_FILE = 'Please upload a file'
  const REQUIRED_FIELD_DATE = 'Please select a date'
  const REQUIRED_FIELD_TIME = 'Please select a time'
  const REQUIRED_FIELD_DATETIME = 'Please select a date and time'
  const REQUIRED_FIELD_EMAIL = 'Please enter a valid email address'
  const REQUIRED_FIELD_PHONE = 'Please enter a valid phone number'
  const REQUIRED_FIELD_ZIP = 'Please enter a valid zip code'

  const isZipCode = (value: string) => {
    const pattern = /^(?:\d{5}(?:-\d{4})?)?$/

    return pattern.test(value)
  }

  const REQUIRED = {
    required: helpers.withMessage(REQUIRED_FIELD_MESSAGE, required)
  }

  const REQUIRED_NUMERIC = {
    required: helpers.withMessage(REQUIRED_FIELD_MESSAGE, required),
    numeric: helpers.withMessage(REQUIRED_FIELD_NUMERIC, (value: string) => !isNaN(Number(value)))
  }

  const REQUIRED_SELECT = {
    required: helpers.withMessage(REQUIRED_FIELD_SELECT, required)
  }

  const REQUIRED_CHECKBOX = {
    required: helpers.withMessage(REQUIRED_FIELD_CHECKBOX, required)
  }

  const REQUIRED_RADIO = {
    required: helpers.withMessage(REQUIRED_FIELD_RADIO, required)
  }

  const REQUIRED_FILE = {
    required: helpers.withMessage(REQUIRED_FIELD_FILE, required)
  }

  const REQUIRED_DATE = {
    required: helpers.withMessage(REQUIRED_FIELD_DATE, required)
  }

  const REQUIRED_TIME = {
    required: helpers.withMessage(REQUIRED_FIELD_TIME, required)
  }

  const REQUIRED_DATETIME = {
    required: helpers.withMessage(REQUIRED_FIELD_DATETIME, required)
  }

  const REQUIRED_EMAIL = {
    required: helpers.withMessage(REQUIRED_FIELD_MESSAGE, required),
    email: helpers.withMessage(REQUIRED_FIELD_EMAIL, email)
  }

  const PHONE = {
    minLength: helpers.withMessage(REQUIRED_FIELD_PHONE, minLength(10)),
    maxLength: helpers.withMessage(REQUIRED_FIELD_PHONE, maxLength(14))
  }

  const REQUIRED_PHONE = {
    required: helpers.withMessage(REQUIRED_FIELD_MESSAGE, required),
    minLength: helpers.withMessage(REQUIRED_FIELD_PHONE, minLength(10)),
    maxLength: helpers.withMessage(REQUIRED_FIELD_PHONE, maxLength(14))
  }

  const REQUIRED_ZIP = {
    required: helpers.withMessage(REQUIRED_FIELD_MESSAGE, required),
    zipCode: helpers.withMessage(
      () => REQUIRED_FIELD_ZIP,
      (value: string) => (value ? isZipCode(value) : true)
    )
  }

  const validateRegex = (regex: RegExp, value: string) => regex.test(value)

  return {
    REQUIRED,
    REQUIRED_NUMERIC,
    REQUIRED_EMAIL,
    REQUIRED_SELECT,
    REQUIRED_CHECKBOX,
    REQUIRED_RADIO,
    REQUIRED_FILE,
    REQUIRED_DATE,
    REQUIRED_TIME,
    REQUIRED_DATETIME,
    PHONE,
    REQUIRED_PHONE,
    REQUIRED_ZIP,
    validateRegex
  }
}

export default useValidation
